import { makeVar } from '@apollo/client';

export const init_state_quote = {
  show_plans: false,
  quotationNo: '',
  quotationType: 'New Business',
  quotationStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  members: [
    { selected: false, relationship: 'Self', gender: '' },
    { selected: false, relationship: 'Spouse', gender: '' },
  ],
  location: {
    pincode: '',
    state: '',
    district: '',
    city: '',
    zone: '',
  },
  isExistingEmployee: 'No',
  existingPolicyNumber: '',
  cover: {
    type: '',
    sum_insured: '500000',
    deductibleSumInsured:'500000',
    tenure: '',
  },
  customer: {},
  customerMeta: {},
};

export const init_state_plans = { plans: [], plansChanged: [] };

export const healthQuoteVar = makeVar(init_state_quote);
export const healthPlansVar = makeVar(init_state_plans);

export const initHealthQuoteState = () =>
  healthQuoteVar(init_state_quote);
export const initHealthPlansState = () =>
  healthPlansVar(init_state_plans);

export const updateHealthQuote = (data) =>
  healthQuoteVar({ ...data, show_plans: true });

export const updateCustomerInformation = (customerInformation) =>
  healthQuoteVar({
    ...healthQuoteVar(),
    customer: customerInformation?.customer
      ? customerInformation?.customer
      : {},
    customerMeta: customerInformation?.customerMeta
      ? customerInformation?.customerMeta
      : {},
  });

export const updateHealthQuotePlans = (plans) => {
  healthPlansVar({
    ...healthPlansVar(),
    plans: plans.map((plan) => {
      return { ...plan, premium: plan.premium ? plan.premium : null };
    }),
  });
};

export const updateHealthQuotePlansPremium = (planName, premium) => {
  healthPlansVar({
    ...healthPlansVar(),
    plans: healthPlansVar().plans.map((plan) =>
      plan.name === planName ? { ...plan, premium: premium } : plan,
    ),
    plansChanged: healthPlansVar().plansChanged.filter(
      (changed) => changed !== planName,
    ),
  });
};

export const removeEntirePack = (packName, planName) => {
  healthPlansVar({
    ...healthPlansVar(),
    plans: healthPlansVar().plans.map((p) =>
      p.name === planName
        ? {
            ...p,
            packs: p.packs.map((pack) =>
              pack.name === packName
                ? {
                    ...pack,
                    addOnCovers: pack.addOnCovers.map((add) => ({
                      ...add,
                      selected: false,
                    })),
                  }
                : pack,
            ),
          }
        : p,
    ),
    plansChanged: healthPlansVar().plansChanged.includes(planName)
      ? healthPlansVar().plansChanged
      : [...healthPlansVar().plansChanged, planName],
  });
};

export const addEntirePack = (packName, planName) => {
  healthPlansVar({
    ...healthPlansVar(),
    plans: healthPlansVar().plans.map((p) =>
      p.name === planName
        ? {
            ...p,
            packs: p.packs.map((pack) =>
              pack.name === packName
                ? {
                    ...pack,
                    addOnCovers: pack.addOnCovers.map((add) => ({
                      ...add,
                      selected: true,
                    })),
                  }
                : pack,
            ),
          }
        : p,
    ),
    plansChanged: healthPlansVar().plansChanged.includes(planName)
      ? healthPlansVar().plansChanged
      : [...healthPlansVar().plansChanged, planName],
  });
};

export const toggleAddOn = (addOnName, packName, planName) => {
  healthPlansVar({
    ...healthPlansVar(),
    plans: healthPlansVar().plans.map((p) =>
      p.name === planName
        ? {
            ...p,
            packs: p.packs.map((pack) =>
              pack.name === packName
                ? {
                    ...pack,
                    addOnCovers: pack.addOnCovers.map((add) =>
                      add.name === addOnName
                        ? {
                            ...add,
                            selected: !add.selected,
                          }
                        : add,
                    ),
                  }
                : pack,
            ),
          }
        : p,
    ),
    plansChanged: healthPlansVar().plansChanged.includes(planName)
      ? healthPlansVar().plansChanged
      : [...healthPlansVar().plansChanged, planName],
  });
};

export const resetPlansChanged = () => {
  healthPlansVar({
    ...healthPlansVar(),
    plansChanged: [],
  });
};

export const updateQuotationDetails = (
  quotationNo,
  quotationStatus,
  quoteCreationDate,
) => {
  healthQuoteVar({
    ...healthQuoteVar(),
    quotationNo: quotationNo,
    quotationStatus: quotationStatus,
    quoteCreationDate: quoteCreationDate,
  });
};
